import Introduction from "./components/Introduction";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Homepage from "./components/Home";
import Services from "./components/Services";
import MissionAndVision from "./components/MissionAndVision";
import WhatWeDo from "./components/WhaWeDo";
import WhyChooseUs from "./components/WhyChooseUs";
import FinancialSupportLevels from "./components/FinancialSupportLevels";
import Testimonials from "./components/Testimonials";
import AboutUs from "./components/AboutUs";
import ContactBar from "./components/ContactBar";
import WhatsAppWidget from "./components/WhatsAppWidget";

function App() {
  return (
    <>
      <Header />
      <div id="home">
        <Homepage />
      </div>
      <div id="introduction">
        <Introduction />
      </div>
      <div id="services">
        <Services />
      </div>
      <div id="mission">
        <MissionAndVision />
      </div>
      <div id="what-we-do">
        <WhatWeDo />
      </div>
      <div id="why-choose-us">
        <WhyChooseUs />
      </div>
      <div id="support-levels">
        <FinancialSupportLevels />
      </div>
      <div id="testimonials">
        <Testimonials />
      </div>
      <div id="about">
        <AboutUs />
      </div>
      <div id="contact">
        <ContactBar />
      </div>
      <Footer />
      <WhatsAppWidget />
    </>
  );
}

export default App;
